
<div class="container mt-4 p-2">
  <div class="form-section p-2 mb-3" style="background-color:white; border-radius:6px; box-shadow: 0 0 5px rgba(0,0,0,0.1);">
    <h2 class="text-center mb-4">{{ Title }}</h2>
    <h5>公司名稱： {{ CompanyName }}</h5>
    <h5>公司地址： {{ Address }}</h5>
    <h5>公司電話： {{ Telephone }}</h5>
  </div>
  <ng-container  *ngIf="viewType == 0;else final">
    <div class="form-section p-2 mb-3" style="background-color:white; border-radius:6px; box-shadow: 0 0 5px rgba(0,0,0,0.1);">
      <p-inplace>
          <ng-template pTemplate="display">
              <p class="text-center fw-bold" style="color: blue;">閱讀契約內容</p>
          </ng-template>
          <ng-template pTemplate="content">
            <p-scrollPanel #consentFormScrollPanel [style]="{ width: '100%', height: '300px','padding':'10px','border':'1px solid #ced4da','border-radius':'4px' }">
                <p [style]="{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }">{{ consentFormContent }}</p>
            </p-scrollPanel>
          </ng-template>
      </p-inplace>
      <div class="mt-3" style="padding: 3px;text-align: center;">
        <input type="checkbox" id="agree" [(ngModel)]="isAgreed">
        <label for="agree" class="form-label">我已閱讀並同意此條款</label>
      </div>
    </div>
    <form #form="ngForm" (ngSubmit)="submitForm(form)">
      <div class="form-section p-2 mb-3" style="background-color:white; border-radius:6px; box-shadow: 0 0 5px rgba(0,0,0,0.1);">
        <div class="row g-1">

          <!-- 甲方姓名 -->
          <div class="col-12 col-md-6 less-padding">
            <label class="form-label">甲方姓名(飼主) *</label>
            <input class="form-control" name="PartAName" placeholder="請輸入甲方姓名" required [(ngModel)]="model.PartAName" #PartAName="ngModel" maxlength="30">
            <div class="text-danger" *ngIf="PartAName.invalid && PartAName.touched">必填欄位</div>
          </div>

          <!-- 身分證字號 -->
          <div class="col-12 col-md-6 less-padding">
            <label class="form-label">身分證字號 *</label>
            <input class="form-control" name="NationalID" placeholder="請輸入身分證字號" required [(ngModel)]="model.NationalID" #NationalID="ngModel" maxlength="10">
            <div class="text-danger" *ngIf="NationalID.invalid && NationalID.touched">必填欄位</div>
          </div>

          <!-- 聯絡電話 -->
          <div class="col-12 col-md-6 less-padding">
            <label class="form-label">聯絡電話 *</label>
            <input class="form-control" name="Phone" placeholder="請輸入聯絡電話" required [(ngModel)]="model.Phone" #Phone="ngModel" maxlength="10">
            <div class="text-danger" *ngIf="Phone.invalid && Phone.touched">必填欄位</div>
          </div>

          <!-- 通訊地址 -->
          <div class="col-12 col-md-6 less-padding">
            <label class="form-label">通訊地址</label>
            <input class="form-control" name="Address" placeholder="請輸入通訊地址" [(ngModel)]="model.Address" maxlength="200">
          </div>
        </div>
      </div>
      <div class="form-section p-2 mb-3" style="background-color:white; border-radius:6px; box-shadow: 0 0 5px rgba(0,0,0,0.1);">
        <div class="row g-1">
          <!-- Email -->
          <div class="col-12 col-md-6 less-padding">
            <label class="form-label">Email *</label>
            <input class="form-control" name="Email" placeholder="請輸入Email" required [(ngModel)]="model.Email" #Email="ngModel" maxlength="50">
            <div class="text-danger" *ngIf="Email.invalid && Email.touched">必填欄位</div>
          </div>

          <!-- 緊急聯絡人 -->
          <div class="col-12 col-md-6 less-padding">
            <label class="form-label">緊急聯絡人</label>
            <input class="form-control" name="Contact" placeholder="請輸入緊急聯絡人" [(ngModel)]="model.Contact" maxlength="30">
          </div>

          <!-- 緊急聯絡人電話 -->
          <div class="col-12 col-md-6 less-padding">
            <label class="form-label">緊急聯絡人電話</label>
            <input class="form-control" name="ContactTel" placeholder="請輸入緊急聯絡人電話" [(ngModel)]="model.ContactTel" maxlength="10">
          </div>

          <!-- 寵物醫院 -->
          <div class="col-12 col-md-6 less-padding">
            <label class="form-label">寵物醫院</label>
            <input class="form-control" name="Hospital" placeholder="請輸入寵物醫院" [(ngModel)]="model.Hospital" maxlength="100">
          </div>

          <!-- 寵物名稱 -->
          <div class="col-12 col-md-6 less-padding">
            <label class="form-label">寵物名稱</label>
            <input class="form-control" name="PetName" placeholder="請輸入寵物名稱" [(ngModel)]="model.PetName" maxlength="100">
          </div>

          <!-- 寵物品種 -->
          <div class="col-12 col-md-6 less-padding">
            <label class="form-label d-block">寵物品種</label>
            <input class="form-control" name="PetVarity" placeholder="請輸入寵物品種" [(ngModel)]="model.PetVarity" maxlength="10">
            <!-- <p-dropdown class="text-center"
                [options]="VarityList || []"
                [(ngModel)]="model.PetVarity"
                placeholder="請選擇"
                [showClear]="true"
                appendTo="body"
                [ngModelOptions]="{standalone: true}" [style]="{ width: '100%' }">
            </p-dropdown> -->
          </div>

          <!-- 簽署日期 -->
          <div class="col-12 col-md-6 less-padding">
            <label class="form-label">簽署日期</label>
            <p class="text-center fw-bold">{{ model.SignatureTime }}</p>
            
          </div>
        </div>
      </div>
      <div class="form-section p-2 mb-3" style="background-color:white; border-radius:6px; box-shadow: 0 0 5px rgba(0,0,0,0.1);">
        <div class="row g-1">
          <!-- 甲方簽名 -->
          <div class="col-12 col-md-6 less-padding">
            <label class="form-label">甲方簽名</label>
            <div class="d-flex gap-3 align-items-start">
              <div class="sign-box border rounded">
                <canvas #canvas class="sign-canvas"></canvas>
              </div>
            </div>
          </div>

        </div>
        <!-- Buttons -->
        <div class="text-center mt-4 d-grid gap-3">
          <button type="button" class="btn btn-secondary" (click)="clear()">
            清除簽名
          </button>

          <button class="btn btn-primary" type="submit"
            [disabled]="loading || !form.valid || !isSigned || !isAgreed">
            <span *ngIf="loading" class="spinner-border spinner-border-sm"></span>
            資料送出
          </button>
        </div>
      </div>

    </form>
  </ng-container>

  <ng-template #final>
    <div class="form-section p-2 mb-3" style="background-color:white; border-radius:6px; box-shadow: 0 0 5px rgba(0,0,0,0.1);">
      <p class="text-center fw-bold">資料已成功送出，已將契約mail到您的信箱。</p>
      <div class="text-center mt-4">
          <button class="btn btn-primary me-3"
            type="submit" (click)="goBack()">
            回首頁
          </button>
        </div>
    </div>
  </ng-template>
</div>